import { render, staticRenderFns } from "./ExamNormal.vue?vue&type=template&id=0d369be9&"
import script from "./ExamNormal.vue?vue&type=script&lang=js&"
export * from "./ExamNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports